export interface IReassignLicenseRequest {
    LicenseID: number;
    Name: string;
    NotifyEmail: string;
    NotifyOwner: boolean;
    NotifyDesigner: boolean;
    ClearKey: boolean;
}

export class ReassignLicenseRequest implements IReassignLicenseRequest {
    LicenseID: number;
    Name: string;
    NotifyEmail: string;
    NotifyOwner: boolean;
    NotifyDesigner: boolean;
    ClearKey: boolean;
}


